import { useQuery } from "@tanstack/react-query";
import { getRelease } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
function useRelease(id) {
    const { rcbAuthenticationStore } = useStores();
    const releaseQuery = useQuery(QueryKeys.getReleaseById(id), ({ signal })=>{
        return getRelease({
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id: Number(id)
            }
        });
    });
    return releaseQuery;
}
export { useRelease };
